import { generateKeys } from '../utils';
import { userDepartments } from './user';
export const variableFields = generateKeys({
    deposit: {
        value: 'deposit',
        label: 'Deposit',
        type: 'select',
    },
    withdrawal: {
        value: 'withdrawal',
        label: 'Withdrawal',
        type: 'select',
    },
    transaction: {
        value: 'transaction',
        label: 'Transaction',
        type: 'select',
    },
    document: {
        value: 'document',
        label: 'Document',
        type: 'select',
    },
    datepicker: {
        value: 'datepicker',
        label: 'Call back time',
        type: 'datetime',
    },
    demoAccount: {
        value: 'demoAccount',
        label: 'Demo Account',
        type: 'select',
    },
    amount: {
        value: 'amount',
        label: 'New demo balance',
        type: 'number',
    },
    phone: {
        value: 'phone',
        label: 'Phone Number',
        type: 'text',
    },
    missingDocument: {
        value: 'missingDocument',
        label: 'Missing Document',
        type: 'select',
    },
    language: {
        value: 'language',
        label: 'Language',
        type: 'select',
    },
});
export const issueTypes = generateKeys({
    heldDeposits: {
        value: 'heldDeposits',
        label: 'Held Deposits',
        departments: [userDepartments.boFunding.key, userDepartments.boAccountOpening.key],
        variableFields: [
            {
                type: variableFields.deposit.key,
                required: true,
            },
        ],
    },
    enableWithdrawalMethods: {
        value: 'enableWithdrawalMethods',
        label: 'Enable Withdrawal Methods',
        departments: [userDepartments.boFunding.key],
        variableFields: [],
    },
    pendingWithdrawals: {
        value: 'pendingWithdrawals',
        label: 'Pending Withdrawals',
        departments: [userDepartments.boFunding.key],
        variableFields: [
            {
                type: variableFields.withdrawal.key,
                required: false,
            },
        ],
    },
    alternativeWithdrawalMethods: {
        value: 'alternativeWithdrawalMethods',
        label: 'Alternative Withdrawal Methods',
        departments: [userDepartments.boFunding.key],
        variableFields: [],
    },
    arnRequested: {
        value: 'arnRequested',
        label: 'ARN/Swift request',
        departments: [userDepartments.boFunding.key],
        variableFields: [],
    },
    pspTechnicalIssue: {
        value: 'pspTechnicalIssue',
        label: 'PSP Technical Issue',
        departments: [userDepartments.support.key],
        variableFields: [
            {
                type: variableFields.deposit.key,
                required: false,
            },
        ],
    },
    cancellationOfWithdrawal: {
        value: 'cancellationOfWithdrawal',
        label: 'Cancellation of Deposit/Withdrawal',
        departments: [userDepartments.boFunding.key],
        variableFields: [
            {
                type: variableFields.withdrawal.key,
                required: false,
            },
        ],
    },
    duplicateTransactions: {
        value: 'duplicateTransactions',
        label: 'Duplicate Transactions',
        departments: [userDepartments.boFunding.key],
        variableFields: [
            {
                type: variableFields.transaction.key,
                required: false,
            },
        ],
    },
    accountVerification: {
        value: 'accountVerification',
        label: 'Account Verification',
        departments: [userDepartments.boAccountOpening.key],
        variableFields: [],
    },
    documentTranslation: {
        value: 'documentTranslation',
        label: 'Document Translation',
        departments: [userDepartments.boAccountOpening.key],
        variableFields: [
            {
                type: variableFields.document.key,
                required: false,
            },
        ],
    },
    profileChanges: {
        value: 'profileChanges',
        label: 'Profile Changes',
        departments: [
            userDepartments.boAccountOpening.key,
            userDepartments.boFunding.key,
        ],
        variableFields: [],
    },
    alternativeAcceptedDocuments: {
        value: 'alternativeAcceptedDocuments',
        label: 'Alternative Documents',
        departments: [userDepartments.boAccountOpening.key, userDepartments.boFunding.key],
        variableFields: [
            {
                type: variableFields.document.key,
                required: false,
            },
        ],
    },
    suspendedAccount: {
        value: 'suspendedAccount',
        label: 'Suspended Account',
        departments: [
            userDepartments.boAccountOpening.key,
            userDepartments.boFunding.key,
        ],
        variableFields: [],
    },
    accountMigration: {
        value: 'accountMigration',
        label: 'Account Migration',
        departments: [
            userDepartments.boAccountOpening.key,
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
    dormantAccounts: {
        value: 'dormantAccounts',
        label: 'Closed/Dormant Accounts',
        departments: [userDepartments.boAccountOpening.key],
        variableFields: [],
    },
    callbackRequest: {
        value: 'callbackRequest',
        label: 'Callback Request',
        departments: [
            userDepartments.sales.key,
            userDepartments.businessDevelopment.key,
            userDepartments.affiliate.key,
            userDepartments.support.key,
        ],
        variableFields: [
            {
                type: variableFields.datepicker.key,
                required: false,
            },
            {
                type: variableFields.language.key,
                required: false,
            },
        ],
    },
    demoAddition: {
        value: 'demoAddition',
        label: 'Demo Addition',
        departments: [
            userDepartments.support.key,
        ],
        variableFields: [],
    },
    secondaryPhoneAddition: {
        value: 'secondaryPhoneAddition',
        label: 'Secondary Phone Addition',
        departments: [userDepartments.support.key],
        variableFields: [
            {
                type: variableFields.phone.key,
                required: true,
            },
        ],
    },
    phoneVerification: {
        value: 'phoneVerification',
        label: 'Phone Verification',
        departments: [
            userDepartments.support.key,
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
    localDepositorRegistration: {
        value: 'localDepositorRegistration',
        label: 'LD Registration',
        departments: [
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
    vipSignalsRequested: {
        value: 'vipSignalsRequested',
        label: 'Trading Tools Request',
        departments: [userDepartments.sales.key],
        variableFields: [],
    },
    leadAssignment: {
        value: 'leadAssignment',
        label: 'Lead Assignment',
        departments: [
            userDepartments.sales.key,
            userDepartments.partnershipOperations.key,
            userDepartments.businessDevelopment.key,
        ],
        variableFields: [
            {
                type: variableFields.language.key,
                required: false,
            },
        ],
    },
    potentialIB: {
        value: 'potentialIB',
        label: 'Potential IB',
        departments: [
            userDepartments.businessDevelopment.key,
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
    attemptedDeposits: {
        value: 'attemptedDeposits',
        label: 'Attempted Deposits',
        departments: [userDepartments.boFunding.key],
        variableFields: [
            {
                type: variableFields.deposit.key,
                required: false,
            },
        ],
    },
    thirdPartyCases: {
        value: 'thirdPartyCases',
        label: '3rd Party Cases',
        departments: [
            userDepartments.boFunding.key,
        ],
        variableFields: [],
    },
    islamicAccount: {
        value: 'islamicAccount',
        label: 'Islamic Account',
        departments: [
            userDepartments.boAccountOpening.key,
        ],
        variableFields: [],
    },
    missingDepositWithdrawal: {
        value: 'missingDepositWithdrawal',
        label: 'Missing Deposit / Withdrawal',
        departments: [
            userDepartments.boFunding.key,
        ],
        variableFields: [],
    },
    complaints: {
        value: 'complaints',
        label: 'Complaints',
        departments: [
            userDepartments.support.key,
        ],
        variableFields: [],
    },
    toggleAP: {
        value: 'toggleAP',
        label: 'Enable / Disable AP Test',
        departments: [
            userDepartments.boAccountOpening.key,
        ],
        variableFields: [],
    },
    enableInternalTransfers: {
        value: 'enableInternalTransfers',
        label: 'Enable Internal Transfer Functionality',
        departments: [
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
    referredBySales: {
        value: 'referredBySales',
        label: 'Referred by Sales',
        departments: [
            userDepartments.partnershipOperations.key,
        ],
        variableFields: [],
    },
});
export const ticketStatuses = generateKeys({
    unresolved: {
        value: 'unresolved',
        label: 'Unresolved',
    },
    takenOver: {
        value: 'takenOver',
        label: 'Taken Over',
    },
    resolved: {
        value: 'resolved',
        label: 'Resolved',
    },
    pendingExt: {
        value: 'pendingExt',
        label: 'Pending (external)',
    },
    pendingInt: {
        value: 'pendingInt',
        label: 'Pending (internal)',
    },
});
export const ticketResolveReasons = generateKeys({
    caseSolved: {
        value: 'caseSolved',
        label: 'Case Solved',
    },
    duplicate: {
        value: 'duplicate',
        label: 'Duplicate',
    },
    canceledByClient: {
        value: 'canceledByClient',
        label: 'Canceled by Client',
    },
    canceledByAgent: {
        value: 'canceledByAgent',
        label: 'Canceled by Agent',
    },
});
